import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/(app)/org/$org/loop/$loopId/')({
  beforeLoad: async ({ params: { org, loopId } }) => {
    throw redirect({
      to: '/org/$org/loop/$loopId/portfolio',
      params: { org, loopId },
      replace: true,
    });
  },
});
